<template>
  <div>
    <div class="card shadow p-3 mb-3">
      <div class="card-header border-0">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="mb-0">
              {{ $t("new-exchange-tasa") }}
            </h3>
          </div>
        </div>
      </div>
      <div class="p-1">
        <b-form inline class="text-center">
          <div class="ml-auto mx-auto">
            <div class="w-100">
              <b-input-group
                size="sm"
                class="ml-1 table-text"
                prepend="1 Match Coin = a"
              >
                <b-form-input
                  class="form-control w-25"
                  v-model="newTasa"
                  type="number"
                  placeholder="0.00"
                ></b-form-input>
                <b-input-group-append>
                  <b-form-select
                    class="rounded-0"
                    v-model="convert_coin_id"
                    :options="optionRate"
                    size="sm"
                  ></b-form-select>
                  <b-button
                    :disabled="newTasa ? false : true"
                    variant="primary"
                    @click="addTasa()"
                    >{{ $t("add-tasa") }}</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </div>
            <b-row class="mt-3">
              <b-col>
                <strong>MC/MP: </strong> {{ getLatest.whc_whp }}
              </b-col>
              <b-col>
                <strong>MC/USD: </strong> {{ getLatest.whc_usd }}
              </b-col>
              <b-col>
                <strong>MP/USD: </strong> {{ getLatest.whp_usd }}
              </b-col>
            </b-row>
          </div>
        </b-form>
      </div>
    </div>
    <b-overlay :show="exchangesLoading" class="rounded" variant="transparent">
      <template #overlay>
        <b-img
          width="100"
          :src="require('@/assets/img/brand/loader.gif')"
          alt=""
        />
      </template>
      <div class="card shadow p-3">
        <div class="card-header border-0">
          <div class="row align-items-center">
            <div class="col">
              <h3 class="mb-0">
                {{ $t("history-transactions") }}
              </h3>
            </div>
          </div>
        </div>
        <b-row>
          <b-col md="12" class="table-responsive" v-if="viewStyle">
            <b-table
              class="align-items-center table-flush tablesorter table-text"
              hover
              :items="getExchanges"
              :fields="columns"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="
                !Array.isArray(getExchanges) || getExchanges.length == 0
                  ? true
                  : false
              "
            >
              <template v-slot:cell(rate)="data">
                {{ data.item.rate }} {{ data.item.converted_coin }}
              </template>
              <template v-slot:cell(created_at)="data">
                {{ moment(data.item.created_at).format("DD-MM-YYYY HH:mm") }}
                hrs.
              </template>
            </b-table>
          </b-col>
        </b-row>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import helpers from "@/services/helpers";
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";
import moment from "moment";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);
export default {
  name: "user-table",
  components: {
    LineChartGenerator,
  },
  props: {
    type: {
      type: String,
    },
    title: String,
    modal: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    await this.fetchExchangeHistorial();
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      newTasa: "",
      viewStyle: true,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
      convert_coin_id: 2,
      moment,
    };
  },
  methods: {
    ...mapActions({
      fetchExchangeHistorial: "fetchExchangeHistorial",
      addExchangeRate: "addExchangeRate",
    }),

    async addTasa() {
      if (
        await helpers.showMsgConfirm({
          tittle: "are_you_sure?",
          msg: "question_add_tasa",
        })
      ) {
        let payload = {
          convert_coin_id: this.convert_coin_id,
          rate: this.newTasa,
        };
        const res = await this.addExchangeRate(payload);
        if (res?.status == 201) {
          await this.fetchExchangeHistorial();
          this.newTasa = null;
          this.$toast.success(res.message, {
            position: "top-right",
          });
        }
      }
    },
    async changePage(value) {
      await this.fetchExchangeHistorial();
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
  },
  computed: {
    ...mapGetters({
      getExchanges: "getExchanges",
      getLatest: "getLatest",
      exchangesLoading: "exchangesLoading",
      dataStadistic: "exchange/dataStadistic",
    }),
    chartData() {
      return {
        labels: this.dataStadistic.labels,
        datasets: [
          {
            label: this.$t("tasa"),
            tension: 0.2,
            borderWidth: 2,
            borderColor: "#5e72e4",
            pointRadius: 6,
            backgroundColor: "#fff",
            data: this.dataStadistic.rate,
          },
        ],
      };
    },
    columns() {
      return [
        { label: this.$t("coin"), key: "base_coin", class: "text-center" },
        { label: this.$t("tasa"), key: "rate", class: "text-center" },
        { label: this.$t("user"), key: "user", class: "text-center" },
        { label: this.$t("date"), key: "created_at", class: "text-center" },
      ];
    },
    optionRate() {
      return [
        { value: 2, text: "Match Points" },
        { value: 146, text: "Dolar Americano" },
      ];
    },
  },
};
</script>